import { FormControl, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { IdName } from '@shared/models/id-name';
import { Maybe } from '@/types/globals';

// eslint-disable-next-line @typescript-eslint/ban-types
export type Public<T extends object> = Pick<T, keyof T>;
export type ValueOf<T> = T[keyof T];

export type ArrayOfObservables<T extends ArrayLike<unknown>> = { [K in keyof T]: Observable<T[K]> };

export type Form<T> = {
	[P in keyof T]: T[P] extends 'object' ? FormGroup<Form<T[P]>> : FormControl<T[P]>;
};

export type RequireAtLeastOne<T, Keys extends keyof T = keyof T> = Pick<T, Exclude<keyof T, Keys>> &
	{
		[K in Keys]-?: Required<Pick<T, K>> & Partial<Pick<T, Exclude<Keys, K>>>;
	}[Keys];

export type Implements<U extends T, T> = U;

export const isIdName = (value: any): value is IdName => {
	return !!value && value.Id !== undefined && value.Name !== undefined;
};

export const getMeaningfulValue = <T>(value: Maybe<IdName> | Maybe<T>): T => {
	return isIdName(value) ? value?.Id ?? null : value;
};

export const requireNonNull = <T>(value: T | null | undefined, message?: string): T => {
	if (value == null) {
		throw new Error(message ?? 'Expected non-null value');
	}

	return value;
};
